import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosRest";
import { AUTH } from "../../api/urls";
import { toast } from 'react-toastify';
import Div from "../Div";
import Spacing from "../Spacing";

export default function ResendVerificationEmail() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Please enter your email address.");
      return;
    }
    
    setIsLoading(true);
    
    try {
      const response = await axiosInstance.post(AUTH.RESEND_VERIFICATION, { email });
      toast.success(response.data.message);
      // Clear form and redirect after success
      setEmail("");
      setTimeout(() => {
        navigate("/auth");
      }, 3000);
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Failed to resend verification email. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Spacing lg="150" md="150" sm="50" />
      <Div className="container">
        <Div className="row justify-content-center">
        <Div className="col-lg-6">
          <h2 className="cs-section_title">Resend Verification Email</h2>
          <p>
            If you didn't receive the verification email, you can request a new one by entering your email address below.
          </p>
          <Spacing lg="30" md="30" />
          
          <form onSubmit={handleSubmit}>
            <Div className="row">
              <Div className="col-sm-12">
                <label htmlFor="email" className="cs-primary_color">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  className="cs-form_field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              
              <Div className="col-sm-12">
                <button 
                  type="submit"
                  className="cs-btn cs-style1"
                  disabled={isLoading}
                >
                  {isLoading ? "Sending..." : "Resend Verification Email"}
                </button>
              </Div>
            </Div>
          </form>
        </Div>
      </Div>
    </Div>
    </>
  );
}
